import { AccountHeaderButton } from '@/components/AccountHeaderButton';
import { InviteHeaderButton } from '@/components/InviteHeaderButton';
import type { HeaderItem } from '@/components/headerItems/types';

/**
 * The right side of every tab header: the invite action, then the account avatar in the corner.
 *
 * Both are views rather than plain buttons, because a native bar button shows an icon or a
 * word and never both. Invite needs both to read as an action, and the avatar is a picture
 * with a badge. They are separate items so iOS 26 gives each its own glass capsule.
 *
 * One constant shared by every tab, so the slot's contents are the same array on every render.
 */
export const TAB_HEADER_ITEMS: HeaderItem[] = [
  { type: 'view', key: 'invite', render: () => <InviteHeaderButton /> },
  {
    type: 'view',
    key: 'account',
    render: () => <AccountHeaderButton />,
  },
];
